module.exports = __webpack_public_path__ + "media/images/country_flags/cr-9d3bb8235e5d93efbd993fa59508f5d0.png";